// Brief, filter-specific reuse; failed responses are never cached.
const stNavigationRead = (() => {
  const ttl = 15000;
  const storageKey = 'st-navigation-stock:152504795180:r12';
  const pending = new Map();
  let saved = {};
  try { saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}'); } catch {}
  return async (input, signal) => {
    const url = new URL(input, location.href);
    url.searchParams.delete('preview_theme_id');
    url.searchParams.delete('page');
    url.searchParams.sort();
    const key = url.href;
    const now = Date.now();
    Object.keys(saved).forEach(k => { if (!saved[k] || now - saved[k].at >= ttl) delete saved[k]; });
    let html;
    if (saved[key]) html = saved[key].html;
    else {
      if (!pending.has(key)) {
        const request = (async () => {
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(6000) });
          if (!response.ok) throw new Error('Navigation unavailable');
          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          if (!doc.querySelector('[data-st-facets], [data-st-availability]')) throw new Error('Incomplete navigation response');
          if (Object.keys(saved).length >= 64) delete saved[Object.keys(saved)[0]];
          saved[key] = { at: Date.now(), html: text };
          try { sessionStorage.setItem(storageKey, JSON.stringify(saved)); } catch {}
          return text;
        })();
        pending.set(key, request);
        request.finally(() => pending.delete(key)).catch(() => {});
      }
      html = await pending.get(key);
    }
    if (signal?.aborted) throw new Error('Navigation superseded');
    return new DOMParser().parseFromString(html, 'text/html');
  };
})();

(() => {
  const url = new URL(location.href);
  if (url.pathname.endsWith('/collections/toys-games') && url.searchParams.get('st_nav_group') === 'games') {
    url.searchParams.delete('st_nav_group');
    url.searchParams.delete('preview_theme_id');
    url.searchParams.delete('filter.p.product_type');
    ['Games', 'Classic Games', 'Card Games', 'Toy'].forEach(value => url.searchParams.append('filter.p.product_type', value));
    url.searchParams.delete('page');
    location.replace(url.href);
  }
})();
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-st-category-link], a[data-st-refine]');
  if (!link) return;
  const current = new URL(window.location.href);
  const target = new URL(link.href, current);
  if (target.origin !== current.origin) return;
  if (link.hasAttribute('data-st-category-link')) for (const [key, value] of current.searchParams) {
    if ((key.startsWith('filter.') && key !== 'filter.p.product_type') || key === 'sort_by' || key === 'preview_theme_id') {
      if (!target.searchParams.has(key, value)) target.searchParams.append(key, value);
    }
  }
  if (!target.searchParams.has('filter.v.availability')) target.searchParams.set('filter.v.availability', '1');
  target.searchParams.delete('page');
  link.href = target.href;
});

(() => {
  const sizeKey = 'filter.v.option.size';
  let requestVersion = 0;
  const makeUrl = (current, value) => {
    const url = new URL(current);
    url.searchParams.delete(sizeKey);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    if (value !== null) {
      url.searchParams.set(sizeKey, value);
      if (!url.searchParams.has('filter.v.availability')) url.searchParams.set('filter.v.availability', '1');
    }
    return url.href;
  };
  async function updateSizes() {
    const started = performance.now();
    const version = ++requestVersion;
    const row = document.querySelector('[data-st-size-row]');
    if (!row) return;
    const current = new URL(location.href);
    const selected = current.searchParams.getAll(sizeKey).flatMap(value => value.split(','));
    const list = row.querySelector('.st-team-nav__list');
    const candidates = [...list.querySelectorAll('[data-st-size-value]')];
    list.querySelectorAll('a,[data-st-selected-size]').forEach(element => element.remove());
    if (selected.length) {
      const reset = document.createElement('a');
      reset.className = 'st-team-nav__pill';
      reset.dataset.stSizeReset = '';
      reset.textContent = row.dataset.resetLabel;
      reset.href = makeUrl(current, null);
      list.append(reset);
      for (const value of selected) {
        const chip = document.createElement('a');
        chip.href = makeUrl(current, null);
        chip.className = 'st-team-nav__pill';
        chip.dataset.stSelectedSize = value;
        chip.setAttribute('aria-current', 'true');
        chip.textContent = candidates.find(link => link.dataset.stSizeValue === value)?.textContent || value;
        list.append(chip);
      }
    }
    row.dataset.ready = 'loading';
    try {
      let options = candidates;
      if (selected.length || !candidates.length || !current.searchParams.has('filter.v.availability')) {
        const query = new URL(makeUrl(current, null));
        if (!query.searchParams.has('filter.v.availability')) query.searchParams.set('filter.v.availability', '1');
        query.searchParams.set('section_id', 'st-navigation-facets');
        const documentFragment = await stNavigationRead(query);
        if (!documentFragment.querySelector('[data-st-facets]')) throw new Error('Size availability unavailable');
        options = [...documentFragment.querySelectorAll('[data-key="filter.v.option.size"]')]
          .filter(option => Number(option.dataset.count) > 0)
          .map(option => {
            const link = document.createElement('a');
            link.className = 'st-team-nav__pill';
            link.dataset.stSizeValue = option.dataset.value;
            link.textContent = option.dataset.label;
            return link;
          });
      }
      if (version !== requestVersion || !row.isConnected) return;
      for (const option of options) {
        const value = option.dataset.stSizeValue;
        if (selected.includes(value)) continue;
        const link = option.cloneNode(true);
        link.hidden = false;
        link.href = makeUrl(current, value);
        list.append(link);
      }
      row.dataset.ready = 'true';
      row.dataset.loadMs = Math.round(performance.now() - started);
    } catch {
      if (version === requestVersion) row.dataset.ready = 'unavailable';
    }
  }
  document.addEventListener('st:navigation-retry', updateSizes);
  document.addEventListener('on:facet-filters:updated', updateSizes);
  window.addEventListener('popstate', updateSizes);
  updateSizes();
})();

(() => {
  const key = 'filter.p.product_type';
  let generation = 0;
  let controller;
  async function updateTypes() {
    const token = ++generation;
    controller?.abort();
    controller = new AbortController();
    const signal = controller.signal;
    const row = document.querySelector('[data-st-type-row]');
    if (!row) return;
    const started = performance.now();
    const current = new URL(location.href);
    const selected = current.searchParams.getAll(key).flatMap(value => value.split(','));
    const options = [...row.querySelectorAll('[data-st-product-type]')];
    const urlFor = (value) => {
      const url = new URL(current);
      url.searchParams.delete(key);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      if (value !== null) {
        value.split('~').forEach(type => url.searchParams.append(key, type));
        url.searchParams.set('filter.v.availability', '1');
      }
      return url;
    };
    row.querySelectorAll('[data-st-type-reset], [data-st-type-selected]').forEach(link => link.remove());
    const list = row.querySelector('.st-team-nav__list');
    if (selected.length) {
      const reset = document.createElement('a');
      reset.className = 'st-team-nav__pill';
      reset.dataset.stTypeReset = '';
      reset.textContent = row.dataset.resetLabel;
      reset.href = urlFor(null);
      list.prepend(reset);
      for (const value of selected) {
        if (options.some(link => link.dataset.stProductType.split('~').includes(value) && link.dataset.stProductType.split('~').every(type => selected.includes(type)))) continue;
        const active = reset.cloneNode(true);
        delete active.dataset.stTypeReset;
        active.dataset.stTypeSelected = '';
        const nativeOption = [...document.querySelectorAll('#facets input')].find(input => input.name === key && input.value === value);
        active.textContent = nativeOption?.labels?.[0]?.textContent.replace(/\(\d+\)/g, '').trim() || value;
        active.setAttribute('aria-current', 'true');
        list.append(active);
      }
    }
    row.dataset.ready = 'loading';
    row.setAttribute('aria-busy', 'true');
    options.forEach(link => {
      const active = link.dataset.stProductType.split('~').every(type => selected.includes(type));
      link.hidden = !active;
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
      link.href = urlFor(active ? null : link.dataset.stProductType);
    });
    const eligible = new Set();
    const resolved = new Set();
    let revealed = 0;
    delete row.dataset.firstPillMs;
    const revealReadyPrefix = () => {
      if (signal.aborted || token !== generation || !row.isConnected) return;
      while (revealed < options.length && resolved.has(options[revealed])) {
        const link = options[revealed++];
        link.hidden = !eligible.has(link);
        if (!link.hidden && !row.dataset.firstPillMs) row.dataset.firstPillMs = Math.round(performance.now() - started);
      }
    };
    const queue = selected.length ? [] : [...options];
    let requests = 0;
    let failures = 0;
    async function worker() {
      while (queue.length && !signal.aborted) {
        const link = queue.shift();
        const query = urlFor(link.dataset.stProductType);
        query.searchParams.set('section_id', 'st-navigation-availability');
        try {
          requests += 1;
          const html = await stNavigationRead(query, signal);
          const result = html.querySelector('[data-st-availability]');
          if (!result) throw new Error('Availability unavailable');
          if (result.dataset.stAvailability === 'true') eligible.add(link);
        } catch {
          failures += 1;
        } finally {
          resolved.add(link);
          revealReadyPrefix();
        }
      }
    }
    await Promise.all(Array.from({ length: Math.min(3, queue.length) }, worker));
    if (signal.aborted || token !== generation || !row.isConnected) return;
    if (!selected.length) options.forEach(link => { link.hidden = !eligible.has(link); });
    row.dataset.ready = failures ? 'partial' : 'true';
    row.dataset.requests = requests;
    row.dataset.loadMs = Math.round(performance.now() - started);
    row.setAttribute('aria-busy', 'false');
  }
  document.addEventListener('st:navigation-retry', updateTypes);
  document.addEventListener('on:facet-filters:updated', updateTypes);
  window.addEventListener('popstate', updateTypes);
  window.addEventListener('pageshow', event => { if (event.persisted) updateTypes(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateTypes(); });
  updateTypes();
})();

(() => {
  let controller;
  async function refreshNavigationStock() {
    controller?.abort();
    controller = new AbortController();
    const signal = controller.signal;
    const current = new URL(location.href);
    const jobs = [];
    const liveRows = [...document.querySelectorAll('[data-st-live-facet]')];
    const collectionLinks = [...document.querySelectorAll('[data-st-category-link]')];
    async function read(url) {
      return stNavigationRead(url, signal);
    }
    for (const row of liveRows) {
      const key = row.dataset.stLiveFacet;
      const links = [...row.querySelectorAll('[data-st-facet-value]')];
      row.dataset.stockReady = 'loading';
      links.forEach(link => { link.hidden = !link.hasAttribute('aria-current'); });
      if (current.searchParams.has(key)) { row.dataset.stockReady = 'true'; continue; }
      jobs.push(async () => {
        try {
          const query = new URL(current);
          query.searchParams.delete('page');
          query.searchParams.delete('preview_theme_id');
          query.searchParams.set('filter.v.availability', '1');
          query.searchParams.set('section_id', 'st-navigation-facets');
          const html = await read(query);
          if (!html.querySelector('[data-st-facets]')) throw new Error('Navigation unavailable');
          const values = new Set([...html.querySelectorAll('[data-key]')].filter(item => item.dataset.key === key && Number(item.dataset.count) > 0).map(item => item.dataset.value));
          if (signal.aborted || !row.isConnected) return;
          links.forEach(link => {
            link.hidden = !values.has(link.dataset.stFacetValue);
            const destination = new URL(link.href);
            destination.searchParams.set('filter.v.availability', '1');
            destination.searchParams.delete('page');
            link.href = destination.href;
          });
          row.dataset.stockReady = 'true';
        } catch { if (!signal.aborted) row.dataset.stockReady = 'unavailable'; }
      });
    }
    for (const link of collectionLinks) {
      if (link.hasAttribute('aria-current')) continue;
      link.hidden = true;
      link.dataset.stockReady = 'loading';
      jobs.push(async () => {
        try {
          const destination = new URL(link.href, current);
          if (destination.origin !== current.origin) return;
          for (const [key, value] of current.searchParams) {
            if ((key.startsWith('filter.') && key !== 'filter.p.product_type') || key === 'sort_by') {
              if (!destination.searchParams.has(key, value)) destination.searchParams.append(key, value);
            }
          }
          destination.searchParams.set('filter.v.availability', '1');
          destination.searchParams.delete('page');
          const query = new URL(destination);
          query.searchParams.delete('preview_theme_id');
          query.searchParams.set('section_id', 'st-navigation-availability');
          const html = await read(query);
          if (signal.aborted || !link.isConnected) return;
          link.hidden = html.querySelector('[data-st-availability]')?.dataset.stAvailability !== 'true';
          link.href = destination.href;
          link.dataset.stockReady = 'true';
        } catch { if (!signal.aborted) link.dataset.stockReady = 'unavailable'; }
      });
    }
    async function worker() { while (jobs.length && !signal.aborted) await jobs.shift()(); }
    await Promise.all(Array.from({ length: Math.min(3, jobs.length) }, worker));
  }
  document.addEventListener('st:navigation-retry', refreshNavigationStock);
  document.addEventListener('on:facet-filters:updated', refreshNavigationStock);
  window.addEventListener('popstate', refreshNavigationStock);
  window.addEventListener('pageshow', event => { if (event.persisted) refreshNavigationStock(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshNavigationStock(); });
  refreshNavigationStock();
})();




// Preserve successive pill intent while a full-page navigation is still committing.
(() => {
  let pending;
  const clear = () => { pending = null; };
  window.addEventListener('popstate', clear);
  window.addEventListener('pageshow', clear);
  document.addEventListener('on:facet-filters:updated', clear);
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a.st-team-nav__pill');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const current = new URL(location.href);
    const target = new URL(link.href, current);
    if (target.origin !== current.origin) return;
    const row = link.closest('[data-st-size-row], [data-st-live-facet], [data-st-type-row]');
    const key = row?.hasAttribute('data-st-size-row') ? 'filter.v.option.size'
      : row?.hasAttribute('data-st-type-row') ? 'filter.p.product_type'
        : row?.dataset.stLiveFacet;
    if (key && target.pathname === current.pathname) {
      const next = new URL(pending?.pathname === current.pathname ? pending : current);
      next.searchParams.delete(key);
      target.searchParams.getAll(key).forEach(value => next.searchParams.append(key, value));
      if (!next.searchParams.has('filter.v.availability') && target.searchParams.has('filter.v.availability')) {
        target.searchParams.getAll('filter.v.availability').forEach(value => next.searchParams.append('filter.v.availability', value));
      }
      next.searchParams.delete('page');
      next.searchParams.delete('section_id');
      link.href = next.href;
      pending = next;
    } else {
      pending = target;
    }
  });
})();

// Reflect the rendered result total and expose stock-check failures without treating sold-out options as errors.
(() => {
  let scheduled = false;
  const observed = new WeakSet();
  const updateScroll = row => {
    // Measure the last choice, not the cue's own trailing flex gap.
    const last = [...row.querySelectorAll('.st-team-nav__pill:not([hidden])')].at(-1);
    const more = !!last && last.getBoundingClientRect().right > row.getBoundingClientRect().right + 1;
    row.dataset.stMore = String(more);
  };
  const resize = new ResizeObserver(entries => entries.forEach(entry => updateScroll(entry.target)));
  const refresh = () => {
    scheduled = false;
    const total = document.querySelector('[data-st-result-count]');
    document.querySelectorAll('[data-st-visible-count]').forEach(count => {
      if (total && count.textContent.trim() !== total.textContent.trim()) count.textContent = total.textContent;
    });
    document.querySelectorAll('.st-team-nav__scroll').forEach(row => {
      if (!observed.has(row)) {
        observed.add(row);
        row.addEventListener('scroll', () => updateScroll(row), { passive: true });
        resize.observe(row);
      }
      updateScroll(row);
    });
    const feedback = document.querySelector('[data-st-nav-feedback]');
    if (!feedback) return;
    const status = feedback.querySelector('[data-st-nav-status]');
    const retry = feedback.querySelector('[data-st-nav-retry]');
    const pending = document.querySelector('[data-ready="loading"], [data-stock-ready="loading"]');
    const failed = document.querySelector('[data-ready="partial"], [data-ready="unavailable"], [data-stock-ready="unavailable"]');
    const visible = document.querySelector('.st-team-nav__pill:not([hidden])');
    const message = pending ? feedback.dataset.loading : failed ? (visible ? feedback.dataset.partial : feedback.dataset.error) : '';
    if (status.textContent !== message) status.textContent = message;
    const retrying = feedback.dataset.retrying === 'true';
    if (!pending && retrying) {
      if (!failed && document.activeElement === retry) document.querySelector('.st-team-nav__pill:not([hidden])')?.focus({ preventScroll: true });
      delete feedback.dataset.retrying;
    }
    if (feedback.hidden !== !message) feedback.hidden = !message;
    feedback.classList.toggle('st-nav-feedback--loading', Boolean(pending) && !retrying);
    const hideRetry = !failed && !retrying;
    if (retry.hidden !== hideRetry) retry.hidden = hideRetry;
    retry.disabled = Boolean(pending);
  };
  const schedule = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(refresh);
    }
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-st-nav-retry]')) return;
    document.querySelector('[data-st-nav-feedback]').dataset.retrying = 'true';
    document.dispatchEvent(new Event('st:navigation-retry'));
    schedule();
  });
  new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['hidden', 'data-ready', 'data-stock-ready']
  });
  document.addEventListener('on:facet-filters:updated', schedule);
  schedule();
})();
